import { z } from 'zod';
import { ShadowSettingKeySchema } from '../setting';
import { BasicAnimationSetSchema } from './animations';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';

const TimerPinComponentButtonSettingSchema = z.object({
  borderSize: z.number().optional(),
  accentColor: z.string().optional(),
  accentFontColor: z.string().optional(),
  backgroundColor: z.string().optional(),
  borderColor: z.string().optional(),
  fontColor: z.string().optional(),
});

export const TimerPinComponentPinThemeSettingSchema = z.object({
  shadow: ShadowSettingKeySchema,
  borderSize: z.number().optional(),
  borderColor: z.string().optional(),
  backgroundColor: z.string().optional(),
  foregroundColor: z.string().optional(),
  fontColor: z.string().optional(),
  primaryButton: TimerPinComponentButtonSettingSchema.optional(),
  secondaryButton: TimerPinComponentButtonSettingSchema.optional(),
});
export type TimerPinComponentSettingsTheme = z.infer<typeof TimerPinComponentPinThemeSettingSchema>;

const TimerSettingsSchema = BasePinComponentSettingsSchema.extend(
  TimerPinComponentPinThemeSettingSchema.extend(
    z.object({
      seconds: z.number().optional(),
      playSound: z.boolean().optional(),
      animations: BasicAnimationSetSchema.optional(),
    }).shape
  ).shape
);
export type TimerSettings = z.infer<typeof TimerSettingsSchema>;

export const TimerPinComponentTypeSchema = z.literal('TIMER');

export const TimerPinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: TimerPinComponentTypeSchema,
    settings: TimerSettingsSchema,
  }).shape
);
